// extracted by mini-css-extract-plugin
module.exports = {"sm":"0","md":"46.875rem","lg":"63.9375em","xl":"80em","svgWrapper":"PageShare_svgWrapper__Vb687"};